export const version = '2.21.1';
//# sourceMappingURL=version.js.map